import React from 'react';

class Feature extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */
  }

  render() {
    return (
      <React.Fragment>
        <section id="features" className="feature-section ptb-100">
          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-md-4">
                <div className="download-img d-flex align-bottom">
                  <img
                    src="img/security.png"
                    alt="Seguridad Frisbee"
                    className="img-fluid"
                  />
                </div>
              </div>
              <div className="col-md-7">
                <div className="feature-contents section-heading">
                  <h2>
                    Plataforma Ágil y Segura<br />
                    <span>vende, cobra y despacha sin problemas</span>
                  </h2>
                  <p>
                    Protegemos los datos personales y de pago de tus clientes. 
                    Trabajamos con el mejor procesador de pagos del país, asegurando los datos y la privacidad de tus clientes.
                  </p>
                  <p>
                    Recibe tus ventas rápido y eficientemente en tu cuenta bancaria. Nosotros te depositamos cada 48 horas después de recibir tu factura. En tu panel de control puedes revisar tus ventas márgenes de utilidad, productos más vendidos y muchos reportes más.
                  </p>
                  <p>
                    Nuestro equipo de Logística recoge, empaca y entrega tu producto directamente a tu cliente. Por primera vez puedes ver todo el proceso de despacho en tiempo real, en nuestra plataforma web.
                  </p>

                  <ul className="list-inline mt-5">
                    <li className="list-inline-item">
                      <div className="mr-3 icon-box border">
                        <img
                          src="img/CANDADO.svg"
                          alt="icon"
                          className="img-fluid"
                        />
                      </div>
                    </li>
                    <li className="list-inline-item">
                      <div className="mr-3 icon-box border">
                        <img
                          src="img/DINERS.svg"
                          alt="icon"
                          className="img-fluid"
                        />
                      </div>
                    </li>
                    <li className="list-inline-item">
                      <div className="mr-3 icon-box border">
                        <img
                          src="img/VISA.svg"
                          alt="icon"
                          className="img-fluid"
                        />
                      </div>
                    </li>
                    <li className="list-inline-item">
                      <div className="mr-3 icon-box border">
                        <img
                          src="img/MASTERCARD.svg"
                          alt="icon"
                          className="img-fluid"
                        />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default Feature;
